/**
 * Platform Utility Functions
 *
 * Shared utilities for platform detection and capabilities.
 */

import { Platform } from 'react-native';

/**
 * Detects if the current platform is a mobile web browser.
 *
 * Checks:
 * 1. Platform is web
 * 2. User agent contains mobile indicators
 * 3. Device has touch support
 *
 * @returns true if running on mobile web browser, false otherwise
 */
export function isMobileWebBrowser(): boolean {
  if (Platform.OS !== 'web') return false;
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent.toLowerCase();
  const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(ua);
  const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  return isMobileUA && hasTouchSupport;
}
